import {Component, OnInit} from '@angular/core';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {environment} from '~/environments/environment';
import {MatDialog} from '@angular/material/dialog';
import {CommonService} from '@services/common.service';
import {UserService} from '@services/user.service';
import {ActivatedRoute} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {AlertService} from '@services/alert.service';
import {AuthenticationService} from '@services/authentification.service';
import {TrackingService} from '@services/tracking.service';
import {AccountComponent} from '@components/popup/account/account.component';

@Component({
    selector: 'app-plan-pro',
    templateUrl: './plan-pro.component.html',
    styleUrls: ['./plan-pro.component.scss']
})
export class PlanProComponent implements OnInit {
    user: User = Object.assign({}, EMPTY_USER);
    stripe = Stripe(environment.stripeKey);

    success = '';
    error = '';
    duration = 'year';

    loading = false;

    constructor(
        public dialog: MatDialog,
        public commonService: CommonService,
        private userService: UserService,
        private route: ActivatedRoute,
        private http: HttpClient,
        private alertService: AlertService,
        public authenticationService: AuthenticationService,
        public trackingService: TrackingService) {
    }

    ngOnInit(): void {
        this.success = this.route.snapshot.queryParams.success || '';
        this.error = this.route.snapshot.queryParams.error || '';

        if (this.success !== '') {
            this.trackingService.subscribe({value: this.success, currency: 'EUR'});
        }
        if (this.error !== '') {
            this.trackingService.subscribeFail();
        }

        this.user = this.authenticationService.currentUser;

        this.route.params.subscribe(p => {
            var params = p;
            if (params.plan != '' && params.plan != undefined) {
                this.planSelect(params.plan);
            }
        });

        var that = this;
        window.onscroll = function() {
            if (document.getElementsByClassName('pricing-menu').length > 0) {
                if (document.documentElement.scrollTop > 2500) {
                    (document.getElementsByClassName('pricing-menu') as HTMLCollectionOf<HTMLElement>)[0].style.position = 'inherit';
                } else {
                    (document.getElementsByClassName('pricing-menu') as HTMLCollectionOf<HTMLElement>)[0].style.position = 'fixed';
                }
            }

            if (document.getElementsByClassName('pricing-full').length > 0) {
                var rect = document.getElementsByClassName('pricing-full')[0].getBoundingClientRect();
                if (document.documentElement.scrollTop > (rect.top + 850)) {
                    document.getElementsByClassName('princing-head')[0].classList.add('fixed');
                } else {
                    document.getElementsByClassName('princing-head')[0].classList.remove('fixed');
                }
            }
        };
    }

    setDuration(duration) {
        this.duration = duration;
    }

    switchPricing(event: any) {
        var switchPricing = document.getElementsByClassName('switch-pricing') as HTMLCollectionOf<HTMLElement>;
        for (var j = 0; j < switchPricing.length; j++) {
            var target = switchPricing[j].getAttribute('data-target');
            if (target != event.getAttribute('data-target')) {
                console.log('Remove on ' + target);
                switchPricing[j].classList.remove('active');
                var cols = document.getElementsByClassName(target) as HTMLCollectionOf<HTMLElement>;
                for (var k = 0; k < cols.length; k++) {
                    cols[k].style.display = 'none';
                }
            }
        }

        event.classList.add('active');
        var cols = document.getElementsByClassName(event.getAttribute('data-target')) as HTMLCollectionOf<HTMLElement>;
        for (var k = 0; k < cols.length; k++) {
            cols[k].style.display = 'table-cell';
        }
    }

    planSelect(plan) {
        if (this.loading == true) {
            return;
        }

        const dialogRef = this.dialog.open(AccountComponent, {
            width: '480px',
            data: {
                duration: this.duration,
                plan: plan,
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.loading = true;
                this.duration = result;
                this.http.post<any>(`${environment.apiUrl}app/paiement/create-checkout-session`,
                    {plan, duration: this.duration}).subscribe(
                    session => {
                        // this.loading = false;
                        this.trackingService.checkout({value: plan});
                        this.stripe.redirectToCheckout({sessionId: session.id}).then(result => {
                            if (result.error) {
                                alert(result.error.message);
                            }
                        });
                    },
                    (error) => {
                        console.log(error);
                        this.loading = false;
                        this.alertService.error('Erreur');
                    });
            }
        });
    }

    updateCB() {
        this.http.post<any>(`${environment.apiUrl}app/paiement/create-update-checkout-session`, {}).subscribe(
            session => {

                this.stripe.redirectToCheckout({sessionId: session.id}).then(result => {
                    if (result.error) {
                        alert(result.error.message);
                    }
                });
            },
            (error) => {
                console.log(error);
            });
    }
}
